const MODES = {
    MONITORING: 'monitoring',
    PARSING: 'parsing'
}

const scrollToTariffs = () => {
    const tariffs = document.getElementById('tariffs');

    if (tariffs) {
        tariffs.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        return;
    }

    window.location.href = '/#tariffs';
}

export {
    MODES,
    scrollToTariffs
}
